import SubmitEnvPassword from "./SubmitEnvPassword";

const Forbidden = {
	SubmitEnvPassword,
};

export default Forbidden;